import { isCustomWebhookRecipient } from '@splunk/olly-common/Recipients';

angular.module('signalview.detector').service('webhookMtlsTelemetry', [
    '$window',
    function ($window) {
        function getDetectorRules(detector) {
            return detector?.sf_uiModel?.rules || detector?.rules || detector?.sf_rules || [];
        }

        function getWebhookMtlsCounts(detector) {
            const counts = {
                enabledWebhookRecipientCount: 0,
                totalWebhookRecipientCount: 0,
            };

            getDetectorRules(detector).forEach((rule) => {
                (rule.notifications || []).forEach((notification) => {
                    if (!isCustomWebhookRecipient(notification)) {
                        return;
                    }

                    counts.totalWebhookRecipientCount += 1;
                    if (notification.mTLSEnabled) {
                        counts.enabledWebhookRecipientCount += 1;
                    }
                });
            });
            return counts;
        }

        function trackDetectorConfiguration(detector, mode) {
            const { enabledWebhookRecipientCount, totalWebhookRecipientCount } =
                getWebhookMtlsCounts(detector);
            if (totalWebhookRecipientCount === 0) {
                return;
            }

            $window.pendo?.track('webhook-mtls-configuration', {
                mode,
                origin: 'detector',
                enabledWebhookRecipientCount,
                totalWebhookRecipientCount,
            });
        }

        return {
            trackDetectorConfiguration,
        };
    },
]);
